/* global $ */
/* global bq */

/**
 * @var {jQuery} $
 * @var {Object} bq
 * */
/**
 * @constructor
 * @param {HTMLElement} element
 * @param {object} options
 */
bq.docItemsBulkManager = function(element, options) {
    this.options   = options;
    /** @type {jQuery} */
    this.$element  = $(element);
};

/**
 * @type {Object}
 * */
bq.docItemsBulkManager.prototype = {
    gridModeSelector: '[data-bq="selectbox-data"] select.bulk-edit-select',
    DEFAULTS: {},
    $element: undefined,

    /**
     * @this {bq.docItemsBulkManager}
     * */
    init: function () {
        bq.debug.log("Document Items Bulk Manager : init()", this.$element);

        // Grid mode change
        this.$element.off('change', this.gridModeSelector);
        this.$element.on('change', this.gridModeSelector, e => this._handleGridModeChange(e));

        // Toggle showing GL Accounting
        this.$element.off('click', '[data-bulk-manager-role="accounting_update_toggle_header_gl_account"]');
        this.$element.on('click', '[data-bulk-manager-role="accounting_update_toggle_header_gl_account"]', e => this._handleAccountingGlAccountToggle(e));

        // Toggle checkboxes and handle heading-to-lines relations
        this.$element.off('change', 'input[data-bulk-select]');
        this.$element.on('change', 'input[data-bulk-select]', e => this._handleBulkSelectCheckboxChange(e));

        // Apply changes to selected rows when "apply" button or link is pressed
        this.$element.off('click', '[data-bulk-manager-role="submit"]');
        this.$element.on('click', '[data-bulk-manager-role="submit"]', e => this._handleBulkSelectApplyClick(e));

        // Apply changes to selected rows when "cancel" button is pressed
        this.$element.off('click', '[data-bulk-manager-role="cancel"]');
        this.$element.on('click', '[data-bulk-manager-role="cancel"]', e => this._handleBulkSelectCancelClick(e));
    },

    /**
     * Get an array of enabled line checkboxes
     * @param e
     * @returns {*}
     * @private
     */
    _getEnabledLineCheckboxes: function(e) {
        return this._getLineCheckboxes(e).filter(':enabled');
    },

    /**
     * Get an array of all line checkboxes
     * @param e
     * @returns {*}
     * @private
     */
    _getLineCheckboxes: function(e) {
        return this.$element.find('input[data-bulk-select ^= "line-"]');
    },

    /**
     * @param e
     * @private
     */
    _handleGridModeChange: function(e) {
        const $targetElement = $(e.target);
        const url = $targetElement.data('ajax-url'); // data-ajax-url
        const $viewHandlerElement = $targetElement.closest('[data-view-handler]');
        const dataToSend = {
            formData: { new_mode: $targetElement.val(), },
            url: url,
            $viewHandlerElement: $viewHandlerElement,
        };
        dataToSend.successCallback = function() {
            const editRequestFormId = editRequest ? editRequest.form : '';
            const editDocFormSelector = 'form#' + editRequestFormId + '[data-bq="validate-form"]';
            if (!$(editDocFormSelector).parsley()) {
                return;
            }

            // Destroy Parsley inited data and reinit
            $(editDocFormSelector).parsley().destroy();
            $(editDocFormSelector).parsley(bq.global.parsley.defaults);
        };

        const gridVHMessage = $targetElement.data('view-handler-message'); // data-view-handler-message
        bq.helper.throwEvent('bq.viewhandler.progressmessage', $viewHandlerElement, {
            message: gridVHMessage,
        });

        this._sendData(dataToSend);

        e.preventDefault();
    },

    /**
     * @param e
     * @private
     */
    _handleAccountingGlAccountToggle: function (e) {
        const $targetElement = $(e.target);
        const $container = $targetElement.closest('.bulk-select-banner .header-container');
        const disabled = $targetElement.prop('checked') ? false : true;

        // hide-show fields in view and edit forms
        if (disabled) {
            $container.addClass('gl-account-fields-hidden');
        } else {
            $container.removeClass('gl-account-fields-hidden');
        }

        // disable inputs in edit-form
        this.$element
            .find('.gl-account-field input')
            .each((i, el) => { $(el).prop('disabled', disabled); });
    },

    /**
     * @param e
     * @private
     */
    _handleBulkSelectCheckboxChange: function (e) {
        const $targetElement = $(e.target);
        const dataBulkSelect = $targetElement.data('bulk-select');
        const lineEnabledCheckboxes = this._getEnabledLineCheckboxes();
        const elChecked = $targetElement.prop('checked');
        if (dataBulkSelect === "heading") {
            lineEnabledCheckboxes.map((val,el) => {
                $(el).prop('checked', elChecked); // set their value to whatever is in heading checkbox
            });
        } else if (dataBulkSelect.indexOf('line-') === 0) {
            const allChecked = lineEnabledCheckboxes.filter(':checked').length === lineEnabledCheckboxes.length;
            this.$element
                .find('input[data-bulk-select="heading"]:enabled')
                .prop('checked', allChecked); // set header if all line checkboxes have same state(checked or unchecked)
        }

        // Hide error
        lineEnabledCheckboxes.length && $('#bulk_select_validation_failed').hide();
    },

    /**
     * @param e
     * @private
     */
    _handleBulkSelectApplyClick: function (e) {
        bq.debug.info('click on [data-bulk-manager-role="submit"]', e.target);

        const lineEnabledCheckboxes = this._getEnabledLineCheckboxes();
        const checkedCheckboxes = lineEnabledCheckboxes.filter(':checked');

        const nothingChecked = checkedCheckboxes.length === 0;
        const allChecked = checkedCheckboxes.length === lineEnabledCheckboxes.length;
        const gridMode = this.$element.find(this.gridModeSelector).val();
        let errorMessage;

        if (nothingChecked) {
            errorMessage = bq.messages.global.bulk_update_select_line_item || '';
        } else if (gridMode === 'bulk_remove_items' && allChecked) {
            errorMessage = bq.messages.global.bulk_update_all_items_cannot_be_removed_from_s || '';
            const entityType = $('form[name="edit_request_form"]').length
                ? bq.messages.global.request
                : bq.messages.global.purchase_order;
            errorMessage = errorMessage.replace('%s', entityType);
        }

        if (errorMessage !== undefined) {
            bq.helper.throwEvent('bq.notification', $(document), {
                id: 'notification_bq-ui-1',
                text: errorMessage,
                type: 'error'
            });

            e.preventDefault();
            return;
        }

        const url = this.options['editUrl']; // data-edit-url
        const actionType = (gridMode === 'bulk_remove_items')
            ? 'remove'
            : 'update_accounting';
        editRequest.update(url, undefined, undefined, actionType);

        e.preventDefault();
    },

    /**
     * @param e
     * @private
     */
    _handleBulkSelectCancelClick: function(e) {
        const url = this.options['bulkSelectCancelChangesUrl']; // data-bulk-select-cancel-changes-url
        const $targetElement = $(e.target);
        const $viewHandlerElement = $targetElement.closest('[data-view-handler]');
        const dataToSend = {
            url: url,
            $viewHandlerElement: $viewHandlerElement,
        };

        const gridVHMessage = $targetElement.data('view-handler-message'); // data-view-handler-message
        bq.helper.throwEvent('bq.viewhandler.progressmessage', $viewHandlerElement, { message: gridVHMessage });

        this._sendData(dataToSend);

        e.preventDefault();
    },

    /**
     * @param data
     * @private
     */
    _sendData: function (data) {
        let self = this,
            successCallback = data.successCallback || function () {},
            stopCallback = data.stopCallback || function () {},
            errorsCallback = data.errorsCallback || function () {},
            $viewHandlerElement = data.$viewHandlerElement || {};

        $.ajax({
            type: 'post',
            url: data.url,
            data: data.formData,
            success: function (resp) {
                //If response is not JSON...
                if (resp[0] === "<") {
                    errorsCallback();
                    bq.helper.throwEvent('bq.viewhandler.stop', $viewHandlerElement);
                    bq.helper.throwEvent('bq.notification', $(document), {
                        id: 'notification_bq-ui-1',
                        text: bq.messages.global.generalError,
                        type: 'error'
                    });
                    setTimeout(function () {
                        stopCallback();
                    }, 2000);
                    return;
                }

                self._processJSON(resp);

                bq.helper.throwEvent('bq.viewhandler.stop', $viewHandlerElement);

                if (resp.errors) {
                    errorsCallback();
                } else {
                    successCallback();
                }
                setTimeout(function () {
                    stopCallback();
                }, 2000);
            },
            error: function () {
                bq.helper.throwEvent('bq.viewhandler.stop', $viewHandlerElement);
                bq.helper.throwEvent('bq.notification', $(document), {
                    id: 'notification_bq-ui-1',
                    text: bq.messages.global.generalError,
                    type: 'error'
                });
            }
        });
    },

    /**
     * @param jsonObj
     * @private
     */
    _processJSON: function (jsonObj) {
        for (let key in jsonObj) {
            const data = jsonObj[key];
            switch (key) {
                case 'updates':
                    data.forEach(function (obj) {
                        $(obj.selector).html(obj.content);
                    });
                    break;
                case 'forward':
                    bq.helper.throwEvent('bq.viewhandler.keepspinner', this.$element);
                    window.location.href = data;
            }
        }
    }
}

// docItemsBulkManager PLUGIN DEFINITION
// =======================
let docItemsBulkManagerOld = $.fn.docItemsBulkManager;

$.fn.docItemsBulkManager = function (option) {
    return this.each(function () {
        let $this   = $(this);
        /** @type {bq.docItemsBulkManager} */
        let data    = $this.data('bq.docItemsBulkManager');
        let options = $.extend(
            {},
            bq.docItemsBulkManager.DEFAULTS,
            $this.data(),
            typeof(option) === 'object' && option
        );

        if (!data) { $this.data('bq.docItemsBulkManager', (data = new bq.docItemsBulkManager(this, options))); }
        data.init();
    });
};

$.fn.docItemsBulkManager.Constructor = bq.docItemsBulkManager;

// docItemsBulkManager NO CONFLICT
// =================
$.fn.docItemsBulkManager.noConflict = function () {
    $.fn.docItemsBulkManager = docItemsBulkManagerOld;
    return this;
};

// docItemsBulkManager DATA-API
// ==============
bq.docItemsBulkManagerInit = function() {
    $('[data-bq="doc-items-bulk-manager"]').each(function () {
        let $el = $(this);
        if($el.data('bq.docItemsBulkManager')) { return; }
        $el.docItemsBulkManager($el.data());
    });
};

bq.init.push(bq.docItemsBulkManagerInit);